import { useFormik } from 'formik';
import Form from 'react-bootstrap/Form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import CustomAlert from '../../../components/Shared/Alert/CustomAlert';
import { UpdateAprovalGroup, GetApprovalGroupList } from '../../../store/Ame/approvalGroupSlice';
import { DynamicFormSchema } from '../../ValidationForm/validationSchema';

const EditApprovalGroup = ({ data }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name2: data ? data.name2 : '',
      name: data ? data.name : '',
      description: data ? data.description : '',
    },
    enableReinitialize: true,
    validationSchema: DynamicFormSchema(t),
    onSubmit: (values, { resetForm }) => {
      dispatch(
        UpdateAprovalGroup({
          id: data?.id,
          name: values.name,
          name2: values.name2,
          description: values.description,
        })
      )
        .unwrap()
        .then(() => {
          CustomAlert({ action: 'Edit' });
           dispatch(GetApprovalGroupList());
          // Navigate(-1, { replace: true });
          resetForm();
        })
        .catch((error) => {
          CustomAlert({ action: 'Error' });
          console.log(error);
        });
    },
  });

  return (
    <>
      <Form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="exampleFormControlSelect1">
                {t('LocalName')}
              </label>
              <Form.Control
                className="form-control"
                type="text"
                autoComplete="off"
                name="name2"
                onChange={formik.handleChange}
                value={formik.values.name2 || ''}
                isInvalid={!!formik.errors.name2}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
            </div>
          </div>

          <div className="col-xl-6">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="exampleFormControlSelect1">
                {t('GlobalName')}
              </label>
              <Form.Control
                className="form-control"
                type="text"
                autoComplete="off"
                name="name"
                onChange={formik.handleChange}
                value={formik.values.name || ''}
                isInvalid={!!formik.errors.name}
              />
              <Form.Control.Feedback type="invalid">{formik.errors.name2}</Form.Control.Feedback>
            </div>
          </div>

          <div className="col-xl-12">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="exampleFormControlSelect1">
                {t('Note')}
              </label>
              <Form.Control
                className="form-control"
                as="textarea"
                rows={3}
                name="description"
                onChange={formik.handleChange}
                value={formik.values.description || ''}
              />

              <div></div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <div className="d-flex justify-content-between gap-2">
            <button
              disabled={formik.isSubmitting}
              type="submit"
              className="btn btn-lg btn-theme mb-1 w-100">
              {formik.isSubmitting ? (
                <div className="spinner-border spinner-border-sm me-2"></div>
              ) : (
                <i className="fa fa-save fa-fw me-1"></i>
              )}
              {t('Save')}
            </button>
            <button
              type="button"
              className="btn btn-lg  btn-default mb-1 w-100"
              data-bs-dismiss="modal"
              id="closeModalJob">
              <i className="fa fa-power-off fa-fw me-1"></i> {t('Cancel')}
            </button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default EditApprovalGroup;
